require.register("modules/m06/dnu-opt-mod-he-activity/page-38/page-38", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page38 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page38;

  
});

